import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
import type { ItemStatus } from '@material-bank/mb3-projects-client/graphql';
export type ProjectContextQueryData = {
  projectContext: {
    project: {
      id: string;
      title: string;
      slug: string;
      externalId: number;
      status: string;
    };
    sampledItem: {
      id: string;
      status: ItemStatus;
      createdAt: string;
      product: {
        productRef: string;
        name: string;
      };
    } | null;
    canEdit: boolean;
  } | null;
};
export type ProjectContextQueryVars = {
  projectExternalId: number;
  productRef: string;
};
const projectContextQuery = gql`
  query ProjectContext($projectExternalId: Int!, $productRef: String!) {
    projectContext(
      projectExternalId: $projectExternalId
      productRef: $productRef
    ) {
      project {
        id
        title
        slug
        externalId
        status
      }
      sampledItem {
        id
        status
        createdAt
        product {
          productRef
          name
        }
      }
      canEdit
    }
  }
`;
export function useProjectContextQuery(options) {
  const $ = _c(4);
  const {
    data,
    error,
    loading
  } = useQuery(projectContextQuery, options);
  const t0 = data?.projectContext;
  let t1;
  if ($[0] !== error || $[1] !== loading || $[2] !== t0) {
    t1 = {
      data: t0,
      error,
      loading
    };
    $[0] = error;
    $[1] = loading;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}